import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Input, Select } from 'antd';
import { get } from 'lodash';
// Services
import i18n from 'services/i18n';
// Options
import { HAS_CRITERIA, WORK_PERMISSION } from 'constants/options';

@i18n('form')
export default class WorkPermissionForm extends Component {
  static propTypes = {
    record: PropTypes.object.isRequired,
    form: PropTypes.object.isRequired,
  };

  render() {
    const { record, translate } = this.props;
    const { getFieldDecorator } = this.props.form;

    return (
      <Form>
        <Input.Group compact>
          <Form.Item style={{ marginBottom: 0 }}>
            {getFieldDecorator('isSimPatHasCriterion', {
              initialValue: record.criterion.isSimPatHasCriterion
                ? 'has'
                : 'hasnt',
            })(
              <Select
                style={{ marginRight: 10 }}
                placeholder={translate('chooseOptions')}
                onClick={e => e.stopPropagation()}
              >
                {HAS_CRITERIA.map(item => (
                  <Select.Option key={item.value} value={item.value}>
                    {translate(item.value)}
                  </Select.Option>
                ))}
              </Select>,
            )}
          </Form.Item>
          <Form.Item style={{ marginBottom: 0 }}>
            {getFieldDecorator('workPermission', {
              initialValue: get(record, 'criterion.workPermission', 'B'),
            })(
              <Select
                placeholder={translate('chooseWorkPermission')}
                onClick={e => e.stopPropagation()}
              >
                {WORK_PERMISSION.map(item => (
                  <Select.Option key={item.value} value={item.value}>
                    {item.value}-{translate('permission', 'patient')}
                  </Select.Option>
                ))}
              </Select>,
            )}
          </Form.Item>
        </Input.Group>
      </Form>
    );
  }
}
